import React from 'react';
// import * as actions from './Actions';

export default function ({ sideBarData, eleRef }) {
  var childProfileData = eleRef.state.childlist;
  var selectedchild=eleRef.state.selectedChild;

   let closePopupcommon2 = ()=>{
        document.querySelector(".select_child_popup.addAns-overlay").style.display="none";
    }
  
    return (
        <div className={`select_child_popup select_child_popup_vcc addAns-overlay fade-in`}>
                <div className="select_child_popup_vcc_gr">
                    <div className="closeMarkDoneBtn" onClick={eleRef.closeChildList} >
                        <img className="closeBtnImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/closeBtn.png"></img>
                    </div>
                    <div className="all_select_child_popups vaccination_select_child_popups" style={{ display: "block" }}>
                        <div className="select_child_heading_view vaccination_child_heading_view"> 
                            <div className="child_headeing_text"> Select Child</div>
                            
                        </div>
                        <div className="child_details_cirecl">
                        <ul className="baby_child_login_circle_div">
                        {childProfileData && childProfileData.length > 0 && childProfileData.map((profile,index)=>
                            
                        <li key={index} className={eleRef.state.selectedChild.ChildId == profile.ChildId ? "baby_child1 active":"baby_child1"} onClick={()=>eleRef.getLatestChildData(profile)}   id={"ChilProf_"+profile.ChildId}  >
                            
                            <div className="name_profile">
                        <div className="chld_prof">
                            
                            {profile.IsExpected!=1 && profile.isTryingToConceive >0 && profile.ChildName==""?

                            <div>
                                <img className="no_babyImg dev_chld_prof" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/07-Trying-to-concieve.webp" title={profile.ChildName} />
                                </div>
                            
                            :
                            profile.IsExpected!=1  && profile.childPhoto == "" ?

                                <div>
                                    {
                                        (() => {
                                            const ageYear = parseInt(profile?.Age) || 0;

                                            return ageYear === 0 ? (
                                                <img className="no_babyImg dev_chld_prof"
                                                    src={profile.childPhoto ? profile.childPhoto :
                                                    "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/01-Infant.webp"}
                                                    title={profile.ChildName}
                                                />
                                            ) : ageYear < 2 ? (
                                                <img className="no_babyImg dev_chld_prof"
                                                    src={profile.childPhoto ? profile.childPhoto  
                                                    : "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/02-Baby.webp"}
                                                    title={profile.ChildName}
                                                />
                                            ) : ageYear < 4 ? (
                                                <img className="no_babyImg dev_chld_prof"
                                                    src={profile.childPhoto ? profile.childPhoto:
                                                    "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/03-Toddler.webp"}
                                                    title={profile.ChildName}
                                                />
                                            ) : (
                                                <img className="no_babyImg dev_chld_prof"
                                                    src={profile.childPhoto ? profile.childPhoto:
                                                    "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/05-Big Kids.webp"}
                                                    title={profile.ChildName}
                                                />
                                            );
                                        })()
                                    }
                                </div>
                            
                                :profile.IsExpected==1 ? 
                                    (<img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp" title="Expecting Baby" className="dev_chld_prof" />
                                    ):
                                profile.IsExpected==1 && profile.userPic ?  
                                (<img src={(profile.userPic)} title="Expecting Baby" className="dev_chld_prof" />
                                ):
                                
                                (<img src={profile.childPhoto ? profile.childPhoto.replace("http://","https://"):''}className="dev_chld_prof" title={profile.ChildName} /> )}
                            
                        </div>
                        {profile.IsExpected!=1 && profile.ChildId!=""? 
                            <div>
                                <div className="chld_name">
                                    <span className="chld_name_span M15_42">
                                        {profile.ChildName}
                                    </span>
                                </div>
                                </div>
                                :
                                <div>
                                {profile.IsExpected!=1 && profile.isTryingToConceive > 0 ? 
                                <div className="chld_name">
                                    <span className="chld_name_span M15_42">Trying to Concieve</span>
                                </div>:
                                <div className="chld_name">
                                    <span className="chld_name_span M15_42">Expecting</span>
                                </div>
                                }
                            </div>
                        }
                    </div>
                        </li>
                        
                        ) }
                        </ul>
                        </div>
                    </div>
                    
                </div>
        </div>
    )
  }
